export class ScreenRegistry {
  constructor() { this.factories = new Map(); this.instances = new Map(); }
  register(id, factory) {
    const key = String(id || '').trim();
    if (!key || typeof factory !== 'function') throw new TypeError('Screen id and factory are required');
    if (this.factories.has(key)) throw new Error(`Duplicate screen owner: ${key}`);
    this.factories.set(key, factory); return this;
  }
  async get(id) {
    if (!this.factories.has(id)) throw new Error(`Unknown screen: ${id}`);
    if (!this.instances.has(id)) this.instances.set(id, Promise.resolve(this.factories.get(id)()));
    return this.instances.get(id);
  }
  ids() { return [...this.factories.keys()]; }
  destroyAll() {
    for (const ownerOrPromise of this.instances.values()) {
      Promise.resolve(ownerOrPromise).then(owner => {
        owner?.deactivate?.();
        if (typeof owner?.destroy === 'function') owner.destroy();
        else owner?.unmount?.();
      }).catch(() => {});
    }
    this.instances.clear();
  }
}
